import { Directive, HostListener, OnDestroy } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { BaseClass } from './baseclass';
import { BaseService } from './baseservice';

@UntilDestroy()
@Directive()
export class BaseComponent extends BaseClass implements OnDestroy {
  constructor() {
    super();
  }

  // @HostListener allows us to also guard against browser refresh, close, etc.
  @HostListener('window:beforeunload', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  unloadNotification($event: any) {
    if (!this.canDeactivate()) {
      $event.returnValue =
        'This message is displayed to the user in IE and Edge when they navigate without using Angular routing (type another URL/close the browser/etc)';
    }
  }
  public canDeactivate(): boolean | Observable<boolean> {
    return true;
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    this.destroyServices();
  }

  destroyServices() {
    for (const objectName in this) {
      const object = this[objectName];
      if (object instanceof BaseService) {
        if (!object.isGlobal) {
          if (objectName.toLowerCase().indexOf('dataservice') == -1)
            object.destroy();
        }
      }
    }
  }
}
